import { useAppContext } from 'context/AppContext'
import { AuthContext, useAuth } from 'context/AuthContext'
import { ReactElement, useEffect, useState } from 'react'
import { createModal } from '../ModalFactory'
import { ModalWrapper } from '../ModalWrapper'
import CreateCard from './CreateCard'
import DeleteCard from './DeleteCard'
import SaveCardSuccess from './SaveSuccess'
import { Card, CardApi } from './types'

const ModalProvider = createModal(
    AuthContext,
    'CreditCardModal',
    () => (
        <>
            <i className="feather feather-plus mr-4" />
            <span className="circular">Create credit</span>
        </>
    ),
    () => (
        <span className="inline-block w-6 h-6 text-primary text-center font-extralight">
            <i className="feather feather-chevron-left " />
        </span>
    )
)

export const CreateCreditCardModalOpener = ModalProvider.Opener
export const CreateCreditCardModalCloser = ModalProvider.Closer

function CreditCardModal() {
    const { translations } = useAppContext()
    const { CreditCardModal } = useAuth()
    const { attributes, setAttributes, close: closeModal } = CreditCardModal
    const [selected_card, setSelectedCard] = useState<Card>()
    const [new_card, setNewCard] = useState<CardApi>()
    const [card_type, setCardType] = useState<string>('')
    const [back_button_label, setBackButtonLabel] = useState<string>('')

    const [refetch, setRefetch] = useState(false)

    useEffect(() => {
        if (!CreditCardModal.is_open) {
            setRefetch(false)
            setSelectedCard(undefined)
            setNewCard(undefined)
            setAttributes({
                refetch_payments: refetch,
            })
        }
    }, [CreditCardModal.is_open])

    useEffect(() => {
        setSelectedCard(attributes?.selected_card as Card)
    }, [attributes?.selected_card])

    useEffect(() => {
        setBackButtonLabel(attributes?.back_button_label as string)
    }, [attributes?.back_button_label])

    const handleOnModalClosed = () => {
        setRefetch(true)
        closeModal()
    }
    const onDelete = () => {
        setRefetch(true)
    }
    const onCancel = () => {
        closeModal()
    }

    const Render: React.FC = (): ReactElement => {
        if (selected_card)
            return (
                <DeleteCard
                    card={selected_card}
                    onDelete={onDelete}
                    onCancel={onCancel}
                />
            )
        return !new_card ? (
            <CreateCard
                handleSaveSuccess={(card: CardApi, card_type: string) => {
                    setNewCard(card)
                    setCardType(card_type)
                }}
                translations={translations}
            />
        ) : (
            <SaveCardSuccess
                new_card={new_card}
                card_type={card_type}
                back_button_label={back_button_label}
                handleOnModalClosed={handleOnModalClosed}
            />
        )
    }

    return (
        <ModalProvider.Visible>
            <ModalWrapper>
                <Render />
            </ModalWrapper>
        </ModalProvider.Visible>
    )
}

export default CreditCardModal
